<template>
  <div class="tab-pane prio-pane" :class="{ hidden: !active }">

    <div v-if="!total" class="atencao-empty">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <p>Sem prioridades definidas</p>
      <small>Conversas com prioridade aparecerão aqui ordenadas por urgência.</small>
    </div>

    <template v-else>
      <div class="prio-summary">
        <span class="prio-total-count">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          {{ total }} conversa{{ total !== 1 ? 's' : '' }} com prioridade
        </span>
      </div>

      <template v-for="group in groups" :key="group.key">
        <div v-if="group.convs.length" class="prio-group">

          <div class="prio-group-head">
            <span class="prio-group-dot" :style="{ background: group.color }"></span>
            <span class="prio-group-label">{{ group.label }}</span>
            <span class="prio-group-count">{{ group.convs.length }}</span>
          </div>

          <div class="prio-grid">
            <div v-for="c in group.convs" :key="c.id" class="prio-card">

              <div class="prio-card-badge" :style="{ background: group.color + '22', color: group.color, borderColor: group.color + '55' }">
                <span class="prio-card-dot" :style="{ background: group.color }"></span>
                {{ group.label }}
              </div>

              <div class="prio-card-head" :style="{ background: `linear-gradient(135deg, ${group.color}12 0%, var(--white) 60%)` }">
                <div class="prio-av" :style="{ background: avatarColor(c.contact.name) }">
                  <img v-if="c.contact.thumbnail" :src="c.contact.thumbnail" :alt="c.contact.name"
                    style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;"
                    @error="(e) => (e.target as HTMLImageElement).style.display='none'" />
                  <span v-else>{{ initials(c.contact.name) }}</span>
                </div>
                <div class="prio-contact">
                  <div class="prio-name">{{ c.contact.name }}</div>
                  <div v-if="c.contact.phone" class="prio-phone">{{ c.contact.phone }}</div>
                </div>
                <span class="prio-id">#{{ c.id }}</span>
              </div>

              <div class="prio-card-body">

                <div class="prio-row">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                  <span :class="{ 'prio-muted': !c.team }">{{ c.team?.name || 'TypeBot' }}</span>
                </div>

                <div class="prio-row">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <span :class="{ 'prio-muted': !c.assignee }">{{ c.assignee?.name || '— sem agente' }}</span>
                </div>

                <div class="prio-pills">
                  <span class="status-pill" :class="c.status">
                    <span class="sdot"></span>
                    {{ statusLabel(c.status) }}
                  </span>
                  <span class="ch-pill">{{ fmtChannel(c.channel) }}</span>
                </div>

                <div v-if="waitInfo(c).cls !== 'none'" class="prio-wait">
                  <span class="wait-badge" :class="waitInfo(c).cls">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12 6 12 12 16 14"/>
                    </svg>
                    {{ waitInfo(c).label }}
                  </span>
                </div>

                <div class="prio-created">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                  <span>{{ fmtDate(c.created_at) }}</span>
                </div>

                <div v-if="c.labels.length" class="prio-labels">
                  <span v-for="lbl in c.labels" :key="lbl" class="label-chip">{{ lbl.replace(/-|_/g, ' ') }}</span>
                </div>

              </div>

              <div class="prio-card-foot">
                <button class="prio-chat-btn" @click="requestOpenChat(c.id)">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  Ver Conversa
                </button>
              </div>

            </div>
          </div>
        </div>
      </template>
    </template>

  </div>
</template>

<script setup lang="ts">
import { computed, watchEffect } from 'vue'
import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials, fmtWait, fmtChannel } from '@/composables/useHelpers'
import { requestOpenChat } from '@/composables/useChatTrigger'

const props = defineProps<{
  conversations: Conversation[]
  active: boolean
}>()

const emit = defineEmits<{ updateBadge: [count: number] }>()

type PriorityKey = 'urgent' | 'high' | 'medium' | 'low'

const PRIORITY_ORDER: PriorityKey[] = ['urgent', 'high', 'medium', 'low']
const PRIORITY_LABELS: Record<PriorityKey, string> = {
  urgent: 'Urgente',
  high: 'Alta',
  medium: 'Média',
  low: 'Baixa',
}
const PRIORITY_COLORS: Record<PriorityKey, string> = {
  urgent: '#dc2626',
  high: '#ea580c',
  medium: '#ca8a04',
  low: '#2563eb',
}

const withPriority = computed(() =>
  props.conversations.filter(c =>
    c.status !== 'resolved' && c.priority && c.priority !== 'none'
  )
)

const groups = computed(() =>
  PRIORITY_ORDER.map(key => ({
    key,
    label: PRIORITY_LABELS[key],
    color: PRIORITY_COLORS[key],
    convs: withPriority.value.filter(c => c.priority === key),
  }))
)

const total = computed(() => withPriority.value.length)

watchEffect(() => emit('updateBadge', total.value))

function statusLabel(s: string): string {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente' }
  return map[s] || s
}

function waitInfo(c: Conversation) {
  return fmtWait(c.waiting_since)
}

function fmtDate(ts: number): string {
  if (!ts) return '—'
  return new Date(ts * 1000).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}
</script>
